<template>
    <div class="app" :class="bDown ? 'app-overflow' : ''">
        <div class="header">
            <div class="left">
                <div @click="gouloadcase" class="icon-add">发布案例</div>
            </div>
            <div class="middle">
                <div class="capsule">
                    <div class="seach" @click="getShow">搜索</div>
                    <div class="choice icon-arrow" @click="show">
                        <span>{{ city ? city : "请选择" }}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="middle" @click="getShow">按条件搜索案例</div> -->
            <!-- <div class="right" @click="show">
        <span>{{ city ? city : "请选择" }}</span>
      </div> -->
        </div>
        <div class="tab-nav">
            <div :style="{ width: 100 / 4 + '%' }" v-for="(item, index) in searchConf.tab" :key="item.code">
                <p :class="{ active: item.select }" @click="fastSearch(index, 0)">
                    {{ item.name }}
                </p>
            </div>
            <div :style="{ width: 100 / 4 + '%' }">
                <p @click="toAntMap">冷暖风水</p>
            </div>
            <div :style="{ width: 100 / 4 + '%' }" v-for="(item, index) in searchConf.brand" :key="item.code">
                <p :class="{ active: item.select }" @click="fastSearch(index, 1)">
                    {{ item.name }}
                </p>
            </div>
            <div :style="{ width: 100 / 4 + '%' }">
                <p @click="toCommercial">商用净水</p>
            </div>
        </div>
        <div class="search" v-show="bShow">
            <div class="close" @click="getShow"></div>
            <div class="search-box">
                <div class="input-box">
                    <label>小区名称</label>
                    <input type="text" placeholder="输入小区名称或关键字" v-model="rqname" placeholder-class="place" />
                </div>
                <div class="tag-box">
                    <label>案例类型</label>
                    <div class="list">
                        <template v-if="!allCase">
                            <p :class="{ active: item.select }" @click="setSearchConfKey('topic_type', index)" v-for="(item, index) in searchConf.topic_type" :key="index">
                                {{ item.name }}
                            </p>
                        </template>
                        <p :class="{ active: allCase }" @click="selectAllCase()">
                            全部案例
                        </p>
                    </div>
                </div>
                <div class="input-box">
                    <label>产品型号</label>
                    <input type="text" placeholder="输入产品型号搜索" v-model="proType" placeholder-class="place" />
                </div>
                <div class="tag-box">
                    <label>产品品类</label>
                    <div class="list">
                        <template v-if="!allCategory">
                            <p :class="{ active: item.select }" @click="setSearchConfKey('cate', index)" v-for="(item, index) in searchConf.cate" :key="index">
                                {{ item.name }}
                            </p>
                        </template>
                        <p :class="{ active: allCategory }" class="tag" @click="selectAllCategory">
                            全部
                        </p>
                    </div>
                </div>
                <div class="tag-box">
                    <label>品牌</label>
                    <div class="list">
                        <template>
                            <p :class="{ active: item.select }" @click="setSearchConfKey('brand', index)" v-for="(item, index) in searchConf.brand" :key="index">
                                {{ item.name }}
                            </p>
                        </template>
                    </div>
                </div>
                <div class="footer-btn">
                    <p @click="bShow = false">取消</p>
                    <p class="active" @click="getseash(true)">确定</p>
                </div>
            </div>
        </div>

        <!-- 选择品类 -->
        <div class="popue" v-if="bDown">
            <div class="catcent" @click.stop="getbDown"></div>
            <div class="category">
                <div class="ocrolll">
                    <ul>
                        <li v-for="(item, index) in getlistserd" :key="index" @click.stop="getcateg(item.cate_name, item.id)">
                            {{ item.cate_name }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 案例列表 -->
        <div class="caselist" :style="{ 'padding-top': searchConf.tab.length > 4 ? '50px' : '' }">
            <pull-to :top-load-method="downRefresh" :bottom-load-method="upRefresh" :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG" :is-bottom-bounce="true" bottom-block-height:0 top-block-height:0>
                <ul class="wrap">
                    <li v-for="(item, index) in caseList" :key="index" @click="goDetails(item.id, item.is_new, item)">
                        <div class="user_item">
                            <div class="user">
                                <img class="user_img" :src="item.avatar" />
                                <div class="info">
                                    <div class="name">{{ item.uname }}</div>
                                    <div class="date">
                                        {{ item.created_at }}
                                    </div>
                                </div>
                            </div>
                            <div class="look">
                                <img src="https://aosmith-asset.ali-cache.com/core/images/eye.png" />
                                <span class="number" id="look">{{
                                    item.views
                                }}</span>
                            </div>
                        </div>
                        <div class="content_words">
                            {{ item.city_name ? item.city_name + "-" : "" }}
                            {{
                                item.address && item.is_new == 1
                                    ? item.address
                                    : ""
                            }}
                            {{
                                item.address && item.is_new == 0
                                    ? item.address
                                    : ""
                            }}
                            {{
                                item.house_area && item.is_new == 1
                                    ? item.house_area + "m²户型"
                                    : ""
                            }}
                            {{
                                item.house_area && item.is_new == 0
                                    ? item.house_area + "m²户型"
                                    : ""
                            }}安装案例
                        </div>
                        <div class="des">
                            <div class="dian" v-for="(
                                    sumititem, sumitindex
                                ) in item.arrCategory" :key="sumitindex" v-show="sumititem.type_name">
                                {{
                                    sumitindex == 0
                                        ? sumititem.type_name
                                        : sumititem.type_name
                                        ? sumititem.type_name
                                        : ""
                                }}
                            </div>
                        </div>
                        <div class="content_pic" v-if="item.imgArr.length">
                            <div class="content_pic_box" v-show="videoindex < 1" v-for="(videoitem, videoindex) in item.videoArr" @click.stop="viewVideoSrc = videoitem.mp4_url" :key="videoitem.id">
                                <video :src="videoitem.mp4_url" :poster="videoitem.mp4_square_cover_url" width="100%" height="auto"></video>
                                <img src="../../assets/images/icon_play.png" class="icon-play" />
                            </div>
                            <div v-for="(uloaditem, uloadindex) in item.imgArr" :key="uloadindex" :class="(uloadindex % 3) - 2 ? '' : 'cladiv'" v-show="uloadindex < 9">
                                <img v-lazy="uloaditem.img_url" v-if="uloaditem.img_id" />
                            </div>
                        </div>
                        <div class="content_pic" v-else-if="item.imgs">
                            <img v-for="(imgitem, imgindex) in item.imgs" :key="imgitem.id" v-lazy="imgitem.url" />
                        </div>
                        <div class="content_pic" v-else>
                            <img src="https://pro-core.babycdn.com/2020/08aosmith/images2020/watersystem/old/default_one_img.png" alt />
                        </div>
                        <div class="other-btn">
                            <div class="btn" @click.stop="item.share_float = true">
                                <img src="../../assets/images/case/icon_sharebtn.png" />
                                <span>{{ item.share_num || 0 }}</span>
                            </div>
                            <div class="btn" @click.stop="collection(item)">
                                <img src="../../assets/images/case/icon_collection.png" v-if="!item.is_collect" />
                                <img src="../../assets/images/case/icon_collection2.png" v-else />
                                <span>{{ item.collect_num || 0 }}</span>
                            </div>
                        </div>

                        <div class="share-box" v-if="item.share_float" @click.stop="item.share_float = false">
                            <div class="share-list">
                                <p class="icon-share" @click.stop="gosarelink(item)">
                                    <span>直接转发分享</span>
                                    <img src="../../assets/images/case/icon_wechat.png" />
                                </p>
                                <!-- <p class="icon-download" @click.stop="gosarelink(item)">
                  <span>保存长图分享</span>
                  <img src="../../assets/images/case/icon_save.png">
                </p> -->
                                <p class="icon-img" @click.stop="gosarea(item)">
                                    <span>添加活动分享</span>
                                    <img src="../../assets/images/case/icon_wechat.png" />
                                </p>
                            </div>
                        </div>
                    </li>
                    <div class="dropload-tip" v-if="bhow">我是有底线的</div>
                </ul>
            </pull-to>
            <div class="tips" v-if="from == 'shopping' && nTips">
                <div class="del" @click="getDel"></div>
                <div class="title">温馨提示</div>
                <div class="text">
                    很遗憾，本地无该型号案例，切换至全国/一键上传
                </div>
            </div>
        </div>
        <!-- 二级联动 -->
        <awesome-picker ref="picker" :anchor="anchor" :data="address" :colorConfirm="sColor" :colorCancel="sColor" swipeTime:500 @cancel="handlePickerCancel" @confirm="handlePickerConfirm" v-if="bPicker"></awesome-picker>

        <!-- 侧边栏 -->
        <div class="sidebar" :class="{ 'sidebar-show': sortFloat }" @click="sortFloat = false">
            <div class="list">
                <div class="item" @click.stop="gocasemap">
                    <img src="../../assets/images/case/icon_list.png" />
                    <p>地图<br />模式</p>
                </div>
                <div class="item" @click.stop="sortFloat = !sortFloat">
                    <img src="../../assets/images/case/icon_sort.png" />
                    <p>排序</p>
                </div>
            </div>
            <div class="sort-list">
                <div class="txt" @click="sortList('collect_num')">
                    收藏量由高到低
                </div>
                <div class="txt" @click="sortList('shares')">
                    转发量由高到低
                </div>
                <div class="txt" @click="sortList('time_asc')">
                    发布时间顺序
                </div>
                <div class="txt" @click="sortList('time_desc')">
                    发布时间倒序
                </div>
            </div>
        </div>

        <div class="video-float" v-if="viewVideoSrc">
            <div class="close" @click="viewVideoSrc = ''">
                <img src="../../assets/images/case/icon_close.png" />
            </div>
            <video :src="viewVideoSrc" width="100%" height="auto" controls="controls" id="video"></video>
        </div>
    </div>
</template>
<script>
import path from "@/path.js";
import PullTo from "vue-pull-to";
export default {
    components: {
        PullTo,
    },
    data() {
        return {
            allCategory: false,
            anchor: [
                {
                    index: 0,
                    value: "",
                },
                {
                    index: 0,
                    value: "",
                },
            ], //默认选中
            sColor: "#2395ff", //picker取消确定按钮颜色
            arrAnchor: [], //初始化默认值
            arrSelect: [],
            bPicker: false,
            bDown: false, //下拉选品类
            bShow: false, //显示隐藏下拉框
            bWhole: false, //选择全部案例
            bMouth: false, //选择口碑案例
            typename: "", //品类
            modelname: "", //型号搜索
            addressShow: true,
            province: "", //省
            city: "", //市
            provinces: "", //省列表
            citys: "", //市列表
            address: [], //地级联动列表
            addressData: [], //未解析的地级联动列表
            addressObj: {
                province: "",
                city: "",
                area_id: "",
            },
            nAddsear: 0, //0城市,1关键词,2城市+关键词
            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },
            BOTTOM_DEFAULT_CONFIG: {
                pullText: "加载中...",
                triggerText: "加载中...",
                loadingText: "加载中...",
                doneText: "加载中...",
                failText: "加载中...",
                loadedStayTime: 0,
                stayDistance: 10,
                triggerDistance: 10,
                bShowloading: true,
            },
            objList: "", //省市id
            caseList: [], //案例列表
            imgArr: [], //户型图片
            getlistserd: [], //品类选择
            parent_id: "", //商品分类id
            nGindex: "", //0为全部，1为口碑
            page: 0, //页码
            loading: false,
            bhow: false,
            latitude: "", //精度
            longitude: "", //纬度
            arrImg: [],
            from: "", //商品详情来源
            nTips: false,

            sortFloat: false,

            // 搜索配置文件
            rqname: "", //小区名字搜索
            proType: "",
            searchConf: {
                house_area: [],
                cate: [],
                topic_type: [],
                tab: [],
                brand: [],
                goods_type: [],
            },
            tab: "",
            sort: {
                time_desc: 0,
                time_asc: 0,
                shares: 0,
                collect_num: 0,
            },
            userinfo: {}, //用户信息

            // 查看的视频
            viewVideoSrc: "",
            allCase: false,
        };
    },
    watch: {
        viewVideoSrc(val) {
            if (val) {
                this.$nextTick(() => {
                    let video = document.getElementById("video");
                    video.play();
                });
            }
        },
    },
    created() {
        // this.getNewLocation();
        // this.getMyLocation();
        this.city = this.$route.query.city;
        this.province = this.$route.query.province;
        this.latitude = this.$route.query.latitude;
        this.longitude = this.$route.query.longitude;
        this.parent_id = this.$route.query.parentid;
        this.modelname = this.$route.query.model;
        this.from = this.$route.query.from; //商品详情来源
        this.$store.commit("loadSwitch", true);
        if (this.modelname) {
            this.proType = this.modelname;
        }
        // console.log("--->", this.$route.query);
        path.post5(path.topicGetConf).then((res) => {
            if (res.data.error == 0) {
                for (let key in res.data.data.result) {
                    let item = res.data.data.result[key];
                    for (let subitem of item) {
                        subitem.select = false;
                    }
                }
                // res.data.data.result.brand.forEach(it=>{
                //     res.data.data.result.tab.push(it)
                // })
                if (this.parent_id) {
                    let arrParent = res.data.data.result.cate.filter((it) => {
                        return it.code == this.parent_id;
                    });
                    arrParent[0].select = true;
                }
                // console.log(res.data.data.result);
                this.searchConf = res.data.data.result;
            } else {
                this.$toast({
                    message: res.data.msg,
                    duration: 1200,
                });
            }
        });
        Promise.all([this.arrgoAddress(), this.getlists()]).then(() => {});
    },
    mounted() {},

    methods: {
        selectAllCategory() {
            this.allCategory = !this.allCategory;
            this.searchConf.cate.forEach((item) => (item.select = false));
        },
        toAntMap() {
            wx.miniProgram.redirectTo({ url: "/pages/ant_map/index/index" });
        },
        toCommercial() {
            wx.miniProgram.redirectTo({ url: "/pages/business/map/index" });
        },
        selectAllCase() {
            if (this.allCase) {
                for (let item of this.searchConf.topic_type) {
                    item.select = false;
                }
            } else {
                for (let item of this.searchConf.topic_type) {
                    item.select = true;
                }
            }
            this.allCase = !this.allCase;
        },
        fastSearch(index, num) {
            if (num == 0) {
                this.searchConf.tab[index].select =
                    !this.searchConf.tab[index].select;
            } else if (num == 1) {
                this.searchConf.brand[index].select =
                    !this.searchConf.brand[index].select;
            }
            this.page = 0;
            this.bhow = false;
            this.caseList = [];
            this.bShow = false;
            this.getCaselist(true);
        },
        setSearchConfKey(key, index) {
            if (key == "cate" && this.searchConf[key][index].code == 0) {
                if (this.searchConf[key][index].select) {
                    this.searchConf[key].forEach((it, nIt) => {
                        if (it.code != 0) {
                            it.select = false;
                        }
                    });
                } else {
                    this.searchConf[key].forEach((it, nIt) => {
                        if (it.code != 0) {
                            it.select = true;
                        }
                    });
                }
                this.searchConf[key][index].select =
                    !this.searchConf[key][index].select;
            } else {
                this.searchConf[key].forEach((it, nIt) => {
                    // console.log(it);
                    if (it.code == 0) {
                        it.select = false;
                    }
                });
                this.searchConf[key][index].select =
                    !this.searchConf[key][index].select;
            }
        },
        //跳转直接分享
        gosarelink(item) {
            this.$store.commit("loadSwitch", true);
            path.post5(path.getUser, {
                user_id: this.$route.query.tp5Userid,
            }).then((res) => {
                // console.log("用户信息", res);
                this.userinfo = res.data.data.result;
                this.$store.commit("loadSwitch", false);
                //判断是否为直销员  ==0  不是直销员
                if (this.userinfo.sell_id == 0) {
                    //  this.$toast({
                    //   message: "您不是直销员",
                    //   duration: 500,
                    // });
                    // setTimeout(() => {
                    wx.miniProgram.navigateTo({
                        url: `/pages/phoneauth/index?url=/pages/case/share/index&userid=${this.$route.query.userid}&topicid=${item.id}`,
                    });
                    // }, 500);
                } else {
                    wx.miniProgram.navigateTo({
                        url: `/pages/case/share/index?userid=${this.$route.query.userid}&topicid=${item.id}`,
                    });
                }
            });
        },
        //跳转添加活动页面
        gosarea(item) {
            this.$store.commit("loadSwitch", true);
            path.post5(path.getUser, {
                user_id: this.$route.query.tp5Userid,
            }).then((res) => {
                // console.log("用户信息", res);
                this.userinfo = res.data.data.result;
                this.$store.commit("loadSwitch", false);
                //判断是否为直销员  sell_id==0:不是直销员
                if (this.userinfo.sell_id == 0) {
                    //  this.$toast({
                    //   message: "您不是直销员",
                    //   duration: 500,
                    // });
                    // setTimeout(() => {
                    wx.miniProgram.navigateTo({
                        url: `/pages/phoneauth/index?url=/pages/watersystem/activity/index&userid=${this.$route.query.userid}&topicid=${item.id}&from=case`,
                    });
                    // }, 500);
                } else {
                    wx.miniProgram.navigateTo({
                        url: `/pages/watersystem/activity/index?userid=${this.$route.query.userid}&topicid=${item.id}&from=case`,
                    });
                }
            });
        },
        //隐藏未搜索到案例弹窗
        getDel() {
            this.from = "";
            // this.modelname='';
            this.parent_id = "";
            this.nTips = false;
            this.getCaselist(true);
        },
        //显示产品品类窗口
        getbDown() {
            this.bDown = !this.bDown;
        },
        //二级联动
        show() {
            this.bPicker = true;
            setTimeout(() => {
                this.$refs.picker.show();
            }, 100);
        },
        //跳转小程序发布案例
        gouloadcase() {
            this.$store.commit("loadSwitch", true);
            path.post5(path.getUser, {
                user_id: this.$route.query.tp5Userid,
            }).then((res) => {
                // console.log("用户信息", res);
                this.userinfo = res.data.data.result;
                this.$store.commit("loadSwitch", false);
                //判断是否为直销员  ==0  不是直销员
                if (res.data.data.result.sell_id == 0) {
                    wx.miniProgram.navigateTo({
                        url: `/pages/phoneauth/index?url=/pages/case/case_release_xue1/index&userid=0&topicid=0`,
                    });
                } else {
                    wx.miniProgram.navigateTo({
                        url: "/pages/case/case_release_xue1/index",
                    });
                }
            });
        },
        //跳转附近案例
        gocasemap() {
            wx.miniProgram.switchTab({ url: "/pages/case/case_map_vue/index" });
        },
        // 收藏
        collection(item) {
            this.$store.commit("loadSwitch", true);
            path.post5(path.topicCollect, {
                xid: item.id,
                type: "topic",
                title:
                    item.province_name +
                    "-" +
                    item.city_name +
                    "-" +
                    item.address,
                user_id: this.$route.query.tp5Userid,
            }).then((res) => {
                this.$store.commit("loadSwitch", false);
                if (res.data.error == 0) {
                    if (item.is_collect) {
                        --item.collect_num;
                    } else {
                        ++item.collect_num;
                    }
                    item.is_collect = !item.is_collect;
                } else {
                    this.$toast({
                        message: res.data.msg,
                        duration: 500,
                    });
                }
            });
        },
        //商品分类
        getlists() {
            let data = {
                cate_id: 0,
                source: "xcx",
                user_id: this.$route.query.userid,
            };
            this.$store.commit("loadSwitch", true);
            path.post5(path.getlists, data).then((res) => {
                //console.log("品类", res);
                if (res.data.error == 0) {
                    this.$store.commit("loadSwitch", false);
                    let getlistserd = res.data.data.result;
                    getlistserd = [
                        ...[{ cate_name: "不限", id: "" }],
                        ...getlistserd,
                    ];
                    this.getlistserd = getlistserd;
                } else {
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: res.data.msg,
                        duration: 1200,
                    });
                }
            });
        },
        //跳转详情
        goDetails(id, isnew, item) {
            // console.log(item);
            //console.log("案例id", id, isnew);
            if (isnew == 0) {
                wx.miniProgram.navigateTo({
                    url: `/pages/case/case_olddetail_vue/index?topicid=${id}&userid=${this.$route.query.userid}`,
                });
            } else if (isnew == 1) {
                wx.miniProgram.navigateTo({
                    url: `/pages/case/case_detail_vue/index?topicid=${id}&userid=${this.$route.query.userid}`,
                });
            }
            item.views++;
        },
        sortList(val) {
            for (let key in this.sort) {
                this.sort[key] = 0;
            }
            this.sort[val] = 1;
            // console.log(this.sort);
            this.getseash(true);
        },
        //案例搜索
        getseash(from) {
            this.from = from;
            // console.log(from);
            this.page = 0;
            this.bhow = false;
            this.caseList = [];
            this.bShow = false;
            if (this.rqname) {
                this.nAddsear = 1;
            } else if (!this.rqname) {
                this.nAddsear = "";
            } else if (this.objList) {
                this.nAddsear = 0;
            } else if (this.rqname && this.objList) {
                this.nAddsear = 2;
            }
            this.getCaselist(from);
        },
        //案例列表
        getCaselist(from) {
            // console.log("来源", from);
            this.nTips = false;
            let arr = [];
            for (let item of this.searchConf.house_area) {
                if (item.select) {
                    arr.push(item.code);
                }
            }
            let area = arr.join(",");
            arr = [];
            let arrBx = this.searchConf.cate.filter((it) => {
                return it.select && it.code == 0;
            });
            if (arrBx.length) {
                arr.push(0);
            } else {
                for (let item of this.searchConf.cate) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
            }
            let parent_id = arr.join(",");
            arr = [];
            for (let item of this.searchConf.brand) {
                // 案列类型
                if (item.select) {
                    arr.push(item.code);
                }
            }
            let brand_id = arr.join(",");
            arr = [];
            let type;
            for (let item of this.searchConf.topic_type) {
                if (item.select) {
                    arr.push(item.code);
                }
            }
            if(this.searchConf.topic_type.length == arr.length){
                type = 'all'
            }else{
                type = arr.join(",");
            }
            let data = {
                style: -1,
                user_id: this.$route.query.userid,
                city_id: this.objList.city_id,
                province_id: this.objList.province_id,
                // search_address: this.nAddsear,
                source: "xcx",
                search_keys: this.rqname,
                page: this.page,
                limit: 10,
                genre: this.nGindex,
                parent_id: parent_id,
                brand_id: brand_id,
                model: this.proType,
                type: type,
                order: JSON.stringify(this.sort),
                area: area,
            };

            if (data.genre == "") {
                delete data.genre;
            }
            if (data.model == "") {
                delete data.model;
            }
            if (data.parent_id == "") {
                delete data.parent_id;
            }
            if (data.search_keys == "") {
                delete data.search_keys;
            }

            // 快速搜索
            if (typeof from == "boolean") {
                arr = [];
                for (let item of this.searchConf.tab) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let subparent_id = arr.join(",");
                // data.search_keys = "";
                data.subparent_id = subparent_id;
                // data.model = "";
                // data.order = "";
                // data.area = "";
            }

            // //console.log("搜索", data);
            this.$store.commit("loadSwitch", true);
            path.post5(path.topicList, data).then((res) => {
                //   console.log("案例列表", res);
                if (res.data.error == 0) {
                    let arrCaselist = res.data.data.result.list;
                    arrCaselist.forEach((item) => {
                        item.imgArr = [];
                        item.videoArr = [];
                        item.share_float = false;
                        item.arrCategory = [];
                        if (item.scence.length) {
                            item.scence.forEach((it) => {
                                if (it.mp4_info) {
                                    if (it.mp4_info.mp4_url) {
                                        item.videoArr.push(it.mp4_info);
                                    }
                                }
                            });
                            item.scence.forEach((it) => {
                                if (item.imgArr.length < 9) {
                                    if (it.house_img.length) {
                                        item.imgArr.push(it.house_img[0]);
                                    }
                                }
                            });
                        }

                        if (item.imgArr.length < 9) {
                            item.scence.forEach((it) => {
                                if (it.house_img.length) {
                                    it.house_img.forEach((itx, index) => {
                                        if (index > 0) {
                                            item.imgArr.push(itx);
                                        }
                                    });
                                }
                            });
                        }
                        item.scence.forEach((it) => {
                            if (it.device_info.length) {
                                it.device_info.forEach((itx, index) => {
                                    item.arrCategory.push(itx);
                                });
                            }
                        });
                        for (let i = 0; i < item.arrCategory.length; i++) {
                            for (let j = i + 1; j < item.arrCategory.length; ) {
                                if (
                                    item.arrCategory[i].id ===
                                    item.arrCategory[j].id
                                ) {
                                    //通过属性进行匹配；
                                    item.arrCategory.splice(j, 1); //去除重复的对象；
                                } else {
                                    j++;
                                }
                            }
                        }
                    });
                    this.$store.commit("loadSwitch", false);
                    if (this.loading) {
                        if (res.data.data.result.list.length < 10) {
                            this.$toast({
                                message: "到底啦~",
                                duration: 800,
                            });
                            this.bhow = true;
                            this.loading = false;
                            this.bShowloading = false;
                            return false;
                        }
                    } else {
                        if (res.data.data.result.list.length == 0) {
                            this.bhow = true;
                            this.loading = false;
                            return false;
                        }
                    }
                    this.caseList = this.caseList.concat(arrCaselist);
                } else {
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: res.data.msg,
                        duration: 1200,
                    });
                }
            });
        },
        //picker点击确定
        handlePickerConfirm: function (e) {
            //console.log("确定", e);
            this.bhow = false; // 切换城市时，不需要直接展示“我是有底线的”，而应该等数据获取后再展示是否显示“我是有底线的”
            let that = this;
            that.caseList = [];
            that.page = 0;
            let select = e;
            that.arrSelect = select;
            let addressData = that.addressData;
            let objprovinces = addressData[0].find((item) => {
                return item.name.indexOf(select[0].value.slice(0, 2)) > -1;
            });
            // //console.log("-->省", objprovinces);
            if (objprovinces) {
                let objCity = addressData[objprovinces.id].find((item) => {
                    // //console.log('=>provincestest',item.name.indexOf(province.slice(0,2)))
                    return item.name.indexOf(select[1].value.slice(0, 2)) > -1;
                });
                let provinceId = objprovinces.id;
                let cityId = objCity.id;
                let province = objprovinces.name;
                let city = objCity.name;
                let obj = {};
                obj.city_id = cityId;
                obj.province_id = provinceId;
                that.objList = obj;
                that.bCancel = true;
                //console.log("-->点击确定",obj)
                that.city = city;
                that.getCaselist(true);
            }
        },
        //picker点击取消
        handlePickerCancel: function () {
            let that = this;
            if (that.bCancel) {
                that.bCancel = false;
                that.anchor = that.arrSelect;
            } else {
                that.bCancel = false;
                // that.anchor = that.anchor;
            }

            this.bPicker = false;
            // that.$refs.picker.show();
            // console.log("点击取消", that.anchor);
        },
        //地级列表
        arrgoAddress: function (callback) {
            var that = this;
            let addressList = [];
            this.$store.commit("loadSwitch", true);
            let promers = function () {
                return new Promise(function (resolve, reject) {
                    that.$store.commit("loadSwitch", true);
                    that.$http
                        .get(
                            "https://pro-core.babycdn.com/2021/aosmith/lottery/china.json"
                        )
                        .then((res) => {
                            // path.post5(path.getFoorplanCity, {}).then((res) => {
                            if (res.body.error == 0) {
                                var addressData = res.body.data.result;
                                that.addressData = addressData;
                                if (that.province) {
                                    let objprovinces = addressData[0].find(
                                        (item) => {
                                            return (
                                                item.name.indexOf(
                                                    that.province.slice(0, 2)
                                                ) > -1
                                            );
                                        }
                                    );
                                    if (objprovinces) {
                                        let objCity = addressData[
                                            objprovinces.id
                                        ].find((item) => {
                                            return (
                                                item.name.indexOf(
                                                    that.city.slice(0, 2)
                                                ) > -1
                                            );
                                        });
                                        let province = objprovinces.name;
                                        let provinceId = objprovinces.id;
                                        let city = objCity.name;
                                        let cityId = objCity.id;
                                        let addressIndex = [];
                                        addressIndex[0] =
                                            addressData[0].findIndex((item) => {
                                                return (
                                                    item.name.indexOf(
                                                        that.province.slice(
                                                            0,
                                                            2
                                                        )
                                                    ) > -1
                                                );
                                            });
                                        addressIndex[1] = addressData[
                                            objprovinces.id
                                        ].findIndex((item) => {
                                            return (
                                                item.name.indexOf(
                                                    that.city.slice(0, 2)
                                                ) > -1
                                            );
                                        });
                                        let obj = {};
                                        obj.city_id = cityId;
                                        obj.province_id = provinceId;
                                        that.objList = obj;
                                        ////console.log("市", city);
                                        //console.log("列表", addressIndex, that.objList);
                                        let anchor = [
                                            {
                                                index: addressIndex[0],
                                                value: province,
                                            },
                                            {
                                                index: addressIndex[1],
                                                value: city,
                                            },
                                        ];
                                        that.anchor = anchor;
                                        that.arrAnchor = anchor;
                                        //         //console.log('anchor',anchor)
                                        that.getCaselist();
                                    } else {
                                        //         ////console.log("-->+++hhhh");
                                        let anchor = [
                                            { index: 0, value: "" },
                                            { index: 0, value: "" },
                                        ];
                                        that.anchor = anchor;
                                        // this.getCaselist();
                                    }
                                } else {
                                    that.getCaselist();
                                }
                                let dataobj = addressData[0];
                                var addressObj = [];
                                for (let p = 0; p < dataobj.length; p++) {
                                    var children = [];
                                    let cityId = dataobj[p].id;
                                    for (
                                        let c = 0;
                                        c < addressData[cityId].length;
                                        c++
                                    ) {
                                        let countyId =
                                            addressData[cityId][c].id;
                                        if (addressData[countyId]) {
                                            var areaList = [];
                                            var areaIdList = [];
                                            for (
                                                let k = 0;
                                                k <
                                                addressData[countyId].length;
                                                k++
                                            ) {
                                                areaList.push(
                                                    addressData[countyId][k]
                                                );
                                                areaIdList.push(
                                                    addressData[countyId][k].id
                                                );
                                            }
                                        }
                                        let cityObj = {
                                            value: addressData[cityId][c].name,
                                            id: addressData[cityId][c].id,
                                            // areaList: areaList,
                                            // areaIdList: areaIdList,
                                        };
                                        children.push(cityObj);
                                    }
                                    let obj = {
                                        value: dataobj[p].name,
                                        id: dataobj[p].id,
                                        children: children,
                                    };
                                    addressObj.push(obj);
                                }
                                addressList = addressObj;
                                resolve(addressList);
                                return;
                            }
                        });
                });
            };
            promers().then((res) => {
                this.address = res;
                this.$store.commit("loadSwitch", false);
                //console.log(this.address);
            });
        },
        //下拉
        downRefresh(loaded) {
            this.page = 0;
            this.bhow = false;
            this.caseList = [];
            this.getCaselist(true);
            loaded("done");
        },
        //上拉
        upRefresh(loaded) {
            let page = this.page + 1;
            this.page = page;
            this.getCaselist(true);
            this.loading = true;
            //console.log("2");
            loaded("done");
        },
        //唤起pick
        openCity: function () {},
        //点击搜索案例初始化
        getShow: function () {
            this.bShow = !this.bShow;
            this.bDown = false;
            // this.bWhole = false;
            // this.bMouth = false;
            // this.modelname = "";
            // this.rqname = "";
            // this.typename = "";
        },
        //点击全部案例
        getwhole: function (index) {
            this.nGindex = index;
            this.bWhole = true;
            this.bMouth = false;
        },
        //点击口碑案例
        getmouth: function (index) {
            this.nGindex = index;
            this.bWhole = false;
            this.bMouth = true;
        },
        //获取选择的品类
        getcateg: function (title, id) {
            this.typename = title;
            this.parent_id = id;
            this.bDown = false;
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .mask {
    display: none !important;
}
::v-deep .picker {
    position: fixed !important;
    left: 0 !important;
    right: 0 !important;
    top: 116px !important;
    z-index: 10000 !important;
    background: #fff !important;
    height: 514px !important;
}
::v-deep .picker-title span {
    font-size: 36px !important;
}
::v-deep .picker-title h4 {
    background: #efefef !important;
}
::v-deep .picker-wheel-wrapper .wheel-scroll .wheel-item {
    font-weight: bold !important;
    color: #707274 !important;
}
::v-deep .picker-panel .picker-mask-top:after {
    border-bottom: 2px solid #add !important;
}
::v-deep .picker-panel .picker-mask-bottom:before {
    border-top: 2px solid #add !important;
}
</style>
<style lang="scss" scoped>
@import "index.scss";
</style>
